import {
  BREAK_REASONS,
  DEFECT_DISPOSITIONS,
  DEFECT_SEVERITIES,
  MOODS,
  NOTE_KINDS,
  NOTE_STATUSES,
  type WorkDefectDisposition,
  type WorkDefectSeverity,
  type WorkDefectStatus,
  type WorkEndReason,
  type WorkNoteKind,
  type WorkNoteStatus,
} from './types';

type BadgeVariant = 'default' | 'secondary' | 'outline' | 'success' | 'info' | 'warning' | 'muted' | 'success-soft' | 'info-soft' | 'warning-soft';

export const SEVERITY_LABEL: Record<WorkDefectSeverity, string> = Object.fromEntries(
  DEFECT_SEVERITIES.map((s) => [s.value, s.label]),
) as Record<WorkDefectSeverity, string>;

export const SEVERITY_VARIANT: Record<WorkDefectSeverity, BadgeVariant> = {
  minor: 'muted',
  major: 'warning-soft',
  critical: 'warning',
};

export const DISPOSITION_LABEL: Record<WorkDefectDisposition, string> = Object.fromEntries(
  DEFECT_DISPOSITIONS.map((d) => [d.value, d.label]),
) as Record<WorkDefectDisposition, string>;

export const DEFECT_STATUS_LABEL: Record<WorkDefectStatus, string> = {
  open: 'Open',
  reviewed: 'Reviewed',
  resolved: 'Resolved',
};

export const DEFECT_STATUS_VARIANT: Record<WorkDefectStatus, BadgeVariant> = {
  open: 'warning-soft',
  reviewed: 'info-soft',
  resolved: 'success-soft',
};

export const NOTE_KIND_LABEL: Record<WorkNoteKind, string> = Object.fromEntries(
  NOTE_KINDS.map((k) => [k.value, k.label]),
) as Record<WorkNoteKind, string>;

export const NOTE_STATUS_LABEL: Record<WorkNoteStatus, string> = Object.fromEntries(
  NOTE_STATUSES.map((s) => [s.value, s.label]),
) as Record<WorkNoteStatus, string>;

export const NOTE_STATUS_VARIANT: Record<WorkNoteStatus, BadgeVariant> = {
  new: 'warning-soft',
  acknowledged: 'info-soft',
  planned: 'info',
  done: 'success-soft',
  declined: 'muted',
};

export const BREAK_REASON_LABEL = Object.fromEntries(BREAK_REASONS.map((b) => [b.value, b.label])) as Record<string, string>;

export const END_REASON_LABEL: Record<WorkEndReason, string> = {
  manual: 'Signed out',
  idle: 'Walked away',
  switched: 'Switched station',
  manager: 'Ended by manager',
  stale: 'Auto-closed',
};

export function moodMeta(mood: number) {
  return MOODS.find((m) => m.value === mood) ?? MOODS[2];
}

/** Colour for a 1–5 mood average. */
export function moodTone(avg: number | null | undefined): string {
  if (avg == null) return 'bg-border';
  if (avg >= 4) return 'bg-bright-moss-dark';
  if (avg >= 3) return 'bg-atmosphere-dark';
  if (avg >= 2) return 'bg-fresh-salmon';
  return 'bg-fresh-salmon-dark';
}
